import { get } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import { useQuery } from '@tanstack/react-query';
import type { TrustGraphView, TrustGraphViewQuery } from '@uncain/shared';

function buildTrustGraphPath(query: TrustGraphViewQuery): string {
	const params = new URLSearchParams();
	params.set('scope', query.scope);
	if (query.repoId) {
		params.set('repoId', query.repoId);
	}
	if (query.workflowPath) {
		params.set('workflowPath', query.workflowPath);
	}
	return `/trust-graph?${params.toString()}`;
}

export function useTrustGraphView(query: TrustGraphViewQuery, enabled = true) {
	return useQuery<TrustGraphView>({
		queryKey: queryKeys.posture.trustGraph(query),
		queryFn: () => get<TrustGraphView>(buildTrustGraphPath(query)),
		enabled,
		staleTime: 30_000,
	});
}
